module.exports = __webpack_public_path__ + "img/13.ec0e6f5a.png";